export default __webpack_public_path__ + "static/media/product-4x300.67c2de31.png";